import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ae3284"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitoring-days-drawer-tasks__drawer-content" }
const _hoisted_2 = { class: "monitoring-days-drawer-tasks__drawer-content-block" }
const _hoisted_3 = { class: "monitoring-days-drawer-tasks__drawer-content-user" }
const _hoisted_4 = { class: "monitoring-days-drawer-tasks__drawer-content-user-data" }
const _hoisted_5 = { class: "monitoring-days-drawer-tasks__drawer-content-user-date" }
const _hoisted_6 = { class: "monitoring-days-drawer-tasks__project-list" }
const _hoisted_7 = { class: "monitoring-days-drawer-tasks__top-info-block" }
const _hoisted_8 = { class: "monitoring-days-drawer-tasks__project-info" }
const _hoisted_9 = { class: "monitoring-days-drawer-tasks__project-name" }
const _hoisted_10 = { class: "monitoring-days-drawer-tasks__total-time-block" }
const _hoisted_11 = { class: "monitoring-days-drawer-tasks__total-time" }
const _hoisted_12 = { class: "monitoring-days-drawer-tasks__drawer-tickets" }
const _hoisted_13 = {
  key: 0,
  class: "monitoring-days-drawer-tasks__line"
}

import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmDrawer,
  TirPmDrawerPositionEnum,
  TirPmIconView,
  TirPmScrollbar,
} from 'tir-components';
import { computed, PropType, ref } from 'vue';
import UserModel from '../../models/UserModel';
import DailySummariesModel from '../../models/DailySummariesModel';
import { OrderTaskModel, TaskColumnModel } from '../../models';
import { TaskViewElementEnum } from '../../enums';
import { TaskDrawerSettingsModel, TaskDrawer } from '@/components';
import { CrossLinedIcon } from 'tir-style-system/icons/outline';
import { TaskCardMonitoring } from '../../components/task-card-monitoring';
import { TaskHeader } from './task-header';
import { ProjectInfoModel } from './task-header/models';
import { ProjectModel } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-days-drawer-tasks',
  props: {
  /**Видимость tir-pm-drawer */
  visibleDrawer: { type: Boolean },
  /**Данные юзера выбранной задачи  */
  selectUserData: { type: Object as PropType<UserModel> },
  /**Данные сводок выбраной задачи  */
  selectDailySummaries: { type: Object as PropType<DailySummariesModel> },
  /**Список задач */
  tasks: {
    type: Array as PropType<OrderTaskModel[]>,
  },
  /**Колонки */
  columns: { type: Array as PropType<TaskColumnModel[]> },
  /**Итоговое время юзера */
  timeSpentUser: { type: Number },
},
  emits: ["EventCloseDrawer", "EventOpenDrawer", "EventonUpdateVisibleDrawer"],
  setup(__props, { emit }) {

const props = __props;





/**Ссылка на компонент шторки задач */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();

/**Настройки видимости */
const viewSettings = ref([
  TaskViewElementEnum.Namespace,
  TaskViewElementEnum.Queue,
  TaskViewElementEnum.Name,
  TaskViewElementEnum.Number,
  TaskViewElementEnum.Status,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
]);

/**Список проектов с задачами */
const projectList = computed(() => {
  const result: ProjectInfoModel[] = [];

  props.tasks.forEach((task) => {
    if (!task.Project) return;

    const existing = result.find((p) => p.Project.Id === task.ProjectId);

    if (existing) {
      existing.Tasks.push(task);
      existing.TotalWorkTime += task.WorkTime;
    } else {
      result.push(
        new ProjectInfoModel({
          Project: task.Project,
          TotalWorkTime: task.WorkTime,
          Tasks: [task],
        }),
      );
    }
  });

  return result;
});

/**Получить день недели */
const getDayWeek = (date: Date) => {
  let newDate = new Date(date);
  newDate.setDate(newDate.getDate());

  const dayOfWeek = newDate.getDay();
  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

  return {
    day: newDate.toLocaleDateString('ru-RU', { weekday: 'short' }).toUpperCase(),
    isWeekend,
  };
};

/**Форматирование даты */
const formatDate = (date: Date) => {
  let newDate = new Date(date);
  newDate.setDate(newDate.getDate());

  const dayOfWeek = getDayWeek(date);
  return (
    newDate.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }) + ` (${dayOfWeek.day})`
  );
};

/**Закрыть дравер */
const closeDrawer = () => {
  emit('EventCloseDrawer');
};

/** Форматирование времени */
const formatTime = (time: number): string => {
  console.log(time);
  
  const hours = Math.floor(time);
  const minutes = Math.round((time - hours) * 100);

  const extraHours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  const totalHours = hours + extraHours;

  const formattedHours = totalHours.toString().padStart(2, '0');
  const formattedMinutes = remainingMinutes.toString().padStart(2, '0');

  return `${formattedHours}ч ${formattedMinutes}м`;
};

/**Открыть шторку с задачей */
const openTaskDrawer = (taskId: number) => {
  emit('EventCloseDrawer');
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'edit',
      TaskId: taskId,
    }),
  );
};

/**Открыть предыдущую шторку */
const openTaskDrawerBack = () => {
  $taskDrawer.value?.close();
  emit('EventOpenDrawer');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmDrawer), {
      visible: __props.visibleDrawer,
      position: _unref(TirPmDrawerPositionEnum).Right,
      panelClass: "monitoring-days-drawer-tasks__drawer",
      overlayClass: "monitoring-days-drawer-tasks__drawer",
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (emit('EventonUpdateVisibleDrawer')))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TirPmIconView), {
                size: 32,
                isRounded: "",
                isBordered: false,
                colorCode: __props.selectUserData?.AvatarColor,
                imageLoadUrl: __props.selectUserData?.Foto
              }, {
                mainSlot: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.selectUserData?.LastName[0]) + _toDisplayString(__props.selectUserData?.FirstName[0]), 1)
                ]),
                _: 1
              }, 8, ["colorCode", "imageLoadUrl"]),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(__props.selectUserData?.LastName) + " " + _toDisplayString(__props.selectUserData?.FirstName) + " " + _toDisplayString(__props.selectUserData?.MiddleName) + " - ", 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(formatDate(__props.selectDailySummaries?.Date)), 1)
              ])
            ]),
            _createVNode(_unref(TirPmButton), {
              size: _unref(TirPmButtonSizeEnum).Regular,
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              onClick: closeDrawer
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(CrossLinedIcon))
              ]),
              _: 1
            }, 8, ["size", "variant"])
          ]),
          _createVNode(_unref(TirPmScrollbar), {
            showOnHover: "",
            class: "monitoring-days-drawer-tasks__scrollbar"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.Project.Id
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(TirPmIconView), {
                          size: 32,
                          isRounded: "",
                          isBordered: false,
                          colorCode: item.Project?.PreviewColor,
                          imageLoadUrl: item.Project?.ImageUrl
                        }, {
                          mainSlot: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.Project?.Name[0]), 1)
                          ]),
                          _: 2
                        }, 1032, ["colorCode", "imageLoadUrl"]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.Project.Name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, " ИТОГО: " + _toDisplayString(formatTime(item.TotalWorkTime)), 1)
                      ])
                    ]),
                    _createVNode(_unref(TaskHeader), {
                      class: "monitoring-days-drawer-tasks__header-table",
                      columns: __props.columns,
                      "view-settings": viewSettings.value
                    }, null, 8, ["columns", "view-settings"]),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Tasks, (task) => {
                        return (_openBlock(), _createBlock(_unref(TaskCardMonitoring), {
                          key: task.Id,
                          task: task,
                          columns: __props.columns,
                          "view-settings": viewSettings.value,
                          hideOpenAndDelete: "",
                          onOpenTaskDrawer: ($event: any) => (openTaskDrawer(task.Id))
                        }, null, 8, ["task", "columns", "view-settings", "onOpenTaskDrawer"]))
                      }), 128))
                    ]),
                    (projectList.value.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible", "position"]),
    _createVNode(_unref(TaskDrawer), {
      ref_key: "$taskDrawer",
      ref: $taskDrawer,
      showBackButton: "",
      onOnBack: openTaskDrawerBack,
      panelClass: "monitoring-days-drawer-tasks__drawer"
    }, null, 512)
  ], 64))
}
}

})